import { Button } from '@/components/ui/button';
import { DeletePropertyDialog } from '@/components/property/DeletePropertyDialog';
import { Video, Trash2, RefreshCw } from 'lucide-react';
import type { IPropertyDetailActionsProps } from '@/@types/property';

export const PropertyDetailActions = ({
  property,
  hasCompletedVideo,
  isDeleteDialogOpen,
  isDeleting,
  onGenerateVideo,
  onDeleteClick,
  onDeleteConfirm,
  onDeleteCancel,
}: IPropertyDetailActionsProps) => {
  return (
    <div className="flex items-center gap-3 pt-4 border-t border-gray-200 dark:border-gray-800">
      {property.status === 'ready' && (
        <Button onClick={onGenerateVideo} className="gap-2">
          <Video className="h-4 w-4" />
          {hasCompletedVideo ? 'Regenerate Video' : 'Generate Video'}
        </Button>
      )}

      {property.status === 'failed' && (
        <Button variant="outline" className="gap-2">
          <RefreshCw className="h-4 w-4" />
          Retry
        </Button>
      )}

      <Button
        variant="outline"
        className="gap-2 text-red-600 hover:text-red-700 hover:bg-red-50"
        onClick={onDeleteClick}
      >
        <Trash2 className="h-4 w-4" />
        Delete
      </Button>

      <DeletePropertyDialog
        isOpen={isDeleteDialogOpen}
        onClose={onDeleteCancel}
        onConfirm={onDeleteConfirm}
        isDeleting={isDeleting}
        propertyTitle={property.title}
      />
    </div>
  );
};
